import { render, staticRenderFns } from "./xinniandaji.vue?vue&type=template&id=b9d18300&"
import script from "./xinniandaji.vue?vue&type=script&lang=js&"
export * from "./xinniandaji.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports